export default "__VITE_ASSET__d4c2279f__"